export interface IndicativeLoanOffer {
    "amount": number,
    "rateOfInterest": number,
    "tenure": number,
    "emi": number,
    "creditOptionId": string,
}

export enum IndicativeLoanOfferStatusCode {
    DPD_OR_SETTLEMENT_EVENTS_OCCURRED, 
    LOW_CREDIT_RISK_SCORE_WEIGHTAGE, 
    HIGH_FINANCIAL_LEVERAGE_WEIGHTAGE,
    LOW_OVERALL_WEIGHTAGE, 
    MIN_LOAN_AMOUNT_REQUIREMENT_FAILURE
}